<template lang="pug">
.channel-guide.inset(
  v-nv:scope="'channel-guide'",
  data-left="channel-list",
  @nv-down="moveList",
  @nv-up="moveList",
  @nv-ch_up="moveList",
  @nv-ch_down="moveList",
  @nv-scope-blur="blured",
  @nv-scope-focus="focused",
  @nv-enter="choose"
)
  .guideBorder.h-100(:class="{ 'primary-bg': allEpgs.length, 'border-right': !allEpgs.length }")
  .sorter(v-visible="sorter")
    .i.fal.fa-sort
  .actions(v-visible="sorter")
    pr-button.play.px-3(small, v-show="watch")
      | {{ $t("Watch") }}
      .i.fal.fa-play.ml-2
    pr-button.play.px-3(small, v-show="startOver")
      | {{ $t("Start over") }}
      .i.fal.fa-undo-alt.ml-2
  .programs.overflow-hidden(v-nv)
    channelProgram.flex-grow-1(
      v-show="allEpgs.length",
      v-for="(item, index) in lazyEpgs",
      :data="item",
      :key="index",
      :background="index === 3",
      :humanize="true",
      :time="true",
      :class="{ activeItem: index === 3 }"
    )
</template>

<script>
import { mapGetters } from "vuex"
import channelProgram from "./channel-program.vue"
export default {
  name: "channel-guide",
  components: { channelProgram },
  data() {
    return {
      activeChannel: null,
      activeItem: 0,
      sorter: false
    }
  },
  computed: {
    allEpgs() {
      let epgs_ = this.$store.state.live.epgs[this.activeChannel?.epg_id] || []
      if (this.activeChannel?.price && !this.activeChannel?.owned) epgs_ = []
      else if (!epgs_.length && this.activeChannel?.hasDvr) epgs_ = _$.dummyEpg()
      return epgs_
    },
    currentProgram() {
      const now = this.$moment().valueOf()
      return this.allEpgs.find(item => item.start < now && item.end > now)
    },
    nextProgram() {
      const now = this.$moment().valueOf()
      return this.allEpgs.find(item => item.start > now)
    },
    activeProgram() {
      return this.currentProgram || this.nextProgram
    },
    activeProgramIndex() {
      return this.activeProgram ? this.allEpgs.indexOf(this.activeProgram) : 0
    },
    selectedProgram() {
      return this.lazyEpgs[3]
    },
    lazyEpgs() {
      let start = _$.untilZero(this.activeItem - 3),
        end = this.activeItem + 4,
        selected = this.allEpgs.slice(start, end)

      let prepend = new Array(_$.untilZero(3 - this.activeItem)).fill(null, 0),
        diff = 7 - [...prepend, ...selected].length,
        append = new Array(diff).fill(null, 0)

      if (this.allEpgs.length >= 7) {
        if (append.length) append = this.allEpgs.slice(0, append.length)
        if (prepend.length) prepend = this.allEpgs.slice(-prepend.length)
      }
      selected = selected.map(item => {
        item.current = item === this.activeChannel.epg?.current
        item.next = item === this.activeChannel.epg?.next
        return item
      })

      return [...prepend, ...selected, ...append]
    },
    /* DVR Operations */
    watch() {
      if (!(this.selectedProgram?.start >= this.activeChannel?.dvr?.from)) return false

      const ts = new Date().getTime()
      return this.selectedProgram.end < ts
    },
    startOver() {
      if (!(this.selectedProgram?.start >= this.activeChannel?.dvr?.from)) return false
      const ts = new Date().getTime()
      const diff = ts - this.selectedProgram.start
      if (diff < 300000) return false

      return this.selectedProgram.start < ts && this.selectedProgram.end > ts
    },
    ...mapGetters("live", ["channels", "channel"])
  },
  mounted() {
    _$.nav.sync("channel-guide")
    _$.vue.$on("channel-guide", e => this.updateChannel(e))
  },
  methods: {
    updateChannel(channel) {
      this.activeChannel = channel
      this.activeItem = this.activeProgramIndex
    },
    blured() {
      this.activeItem = this.activeProgramIndex
      this.sorter = false
    },
    async focused() {
      await this.$nextTick()
      if (!this.allEpgs.length) return _$.sleep(250).then(() => _$.nav.changeScope(_$.nav.prevScopeName()))
      this.sorter = true
    },
    moveList($e) {
      if ($e.detail.value === "down") this.activeItem++
      else if ($e.detail.value === "up") this.activeItem--
      else if ($e.detail.value === "ch_down") this.activeItem = this.activeItem - 7
      else if ($e.detail.value === "ch_up") this.activeItem = this.activeItem + 7

      if (this.activeItem >= this.allEpgs.length) this.activeItem = 0
      else if (this.activeItem < 0) this.activeItem = this.allEpgs.length - 1
    },
    async choose() {
      if (this.activeChannel.pin) {
        const res = await __.media.pinCodeMiddleware(this.activeChannel)
        if (!res) return false
      }

      const activeItem_ = this.activeItem
      if (!this.watch && !this.startOver) return false

      __.platform.fullscreen(true)
      _$.nav.disable()
      await _$.dvr.play({ channel: this.activeChannel, data: this.selectedProgram })
      if (this._inactive) return

      _$.nav.changeScope("channel-guide")
      this.activeItem = activeItem_

      __.platform.fullscreen(false)
      __.media.play(this.activeChannel.channel_uri, true, this.activeChannel)
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-guide {
  padding-left: 5px;
  display: flex;

  .sorter {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 15px;
    z-index: 1;
  }

  .actions {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 15px;
    z-index: 1;
  }

  .programs {
    display: flex;
    flex-grow: 1;
    flex-direction: column;

    .channel-program {
      justify-content: center;
      padding-left: 40px;
      height: 102px !important;
    }

    .activeItem {
      height: 108px !important;
    }
  }

  .guideBorder {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 5px;
    z-index: 1;

    &.border-right {
      width: 0 !important;
    }
  }
}
</style>
